module.exports = __webpack_public_path__ + "static/media/ds-8-powermatic_02.d6d8dcaa.png";